import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { ClassNameMap } from '@mui/styles';

const useStyles = makeStyles(() => ({
  root: {}
}));

type DrawerBodyProps = { classes?: ClassNameMap; children?: React.ReactNode };

export const DrawerBody: React.FC<DrawerBodyProps> = ({
  classes,
  children,
  ...rest
}: DrawerBodyProps) => {
  const cls = useStyles({ classes });
  return (
    <div className={cls.root} data-testid="drawer-body" {...rest}>
      {children}
    </div>
  );
};
